import NewsList from '../../blocks/news-list/scripts.js'
import ArticleBlog from '../../blocks/article-blog/scripts.js'
import PictoDeco from '../../blocks/picto-deco/scripts.js'
import TitleText from '../../blocks/title-text/scripts.js'
import Contact from '../../blocks/contact/scripts.js'
import Accordeon from '../../blocks/accordeon/scripts.js'
import Testimonials from '../../blocks/testimonials/scripts.js'
import SliderImg from '../../blocks/slider-img/scripts.js'
import Hero from '../../blocks/hero/scripts.js'
import SliderDouble from '../../blocks/slider-double/scripts.js'
import PictoList from '../../blocks/picto-list/scripts.js'
import DoubleCta from '../../blocks/double-cta/scripts.js'
import TextCta from '../../blocks/text-cta/scripts.js'
import Footer from '../../blocks/footer/scripts.js'
import Header from '../../blocks/header/scripts.js'
import initReveal from './reveal.js'
import initParallax from './parallax.js'

document.addEventListener('DOMContentLoaded', () => {

  initReveal()
  initParallax()

  document.querySelectorAll('.news-list--masonry').forEach(el => new NewsList(el))
  document.querySelectorAll('.article-blog').forEach(el => new ArticleBlog(el))
  document.querySelectorAll('.picto-deco').forEach(el => new PictoDeco(el))
  document.querySelectorAll('.title-text').forEach(el => new TitleText(el))
  document.querySelectorAll('.contact').forEach(el => new Contact(el))
  document.querySelectorAll('.accordeon').forEach(el => new Accordeon(el))
  document.querySelectorAll('.testimonials').forEach(el => new Testimonials(el))
  document.querySelectorAll('.slider-img').forEach(el => new SliderImg(el))
  document.querySelectorAll('.hero').forEach(el => new Hero(el))
  document.querySelectorAll('.slider-double').forEach(el => new SliderDouble(el))
  document.querySelectorAll('.picto-list').forEach(el => new PictoList(el))
  document.querySelectorAll('.double-cta').forEach(el => new DoubleCta(el))
  document.querySelectorAll('.text-cta').forEach(el => new TextCta(el))
  document.querySelectorAll('.footer').forEach(el => new Footer(el))
  document.querySelectorAll('.header').forEach(el => new Header(el))
});
